import { jetStreamInstance } from "../Leases";
export const mouHeads=[
        { id:'mou_date', label: 'MOU Date', sortOption: false },
        { id:'lessee', label: 'Lessee', sortOption: false },
        { id:'lessor', label: `${jetStreamInstance?'Lessor/Holdco':'Lessor'}`, sortOption: false },
        { id:'managed', label: 'Managed', sortOption: false },
        { id:'asset', label: 'Linked Asset', sortOption: false },
        { id:'created_by', label: 'Created By', sortOption: false },
        { id:'action', label: 'Action', sortOption: false },
]